import React from 'react'
import PropTypes from 'prop-types'
import Tracker from '../tracker'
import Map from '../map/map'
import { useTranslation } from '../../hooks'
import { isProdURL } from '../../utils'
import './_task-progress.scss'

// Progress card of a task: the job location map, when allowed, above the step tracker
function TaskProgress({ steps, mapAllowed, origin, destination }) {
  const { i18n } = useTranslation();
  const googleApiKey = isProdURL()
    ? process.env.REACT_APP_GOOGLE_API_KEY_PROD
    : process.env.REACT_APP_GOOGLE_API_KEY_DEV;

  return (
    <div className="card task-progress">
      <h2 className="task-progress__title">{i18n('cp_progress_tracking')}</h2>
      {mapAllowed && googleApiKey && (
        <div className="task-progress__map">
          <span className="task-progress__map-label">{i18n('cp_job_location')}</span>
          <Map origin={origin} destination={destination} apiKey={googleApiKey} />
        </div>
      )}
      <Tracker items={steps} theme="status" />
    </div>
  )
}

TaskProgress.propTypes = {
  steps: PropTypes.array,
  mapAllowed: PropTypes.bool,
  origin: PropTypes.object,
  destination: PropTypes.object
}

export default TaskProgress
